module.exports = __webpack_public_path__ + "img/rightArrow.f0496c19.png";